// The open sidebar entries across all rows: one registry serves "also selected in",
// map → member row marking, the live cursor and the drawer's last clicked entry.

/**
 * @typedef {{rowName: string, featureId: string, memberIds: string[],
 *   clickedAt: number, element?: unknown, model?: object}} Entry
 */
export function createEntryRegistry() {
  const entries = new Set();
  return {
    add: (entry) => entries.add(entry),
    remove: (entry) => entries.delete(entry),
    entries: () => [...entries],
    alsoSelectedIn: (featureId, rowName) => [
      ...new Set(
        [...entries]
          .filter((e) => e.featureId === featureId && e.rowName !== rowName)
          .map((e) => e.rowName),
      ),
    ],
  };
}
